import { createApp, reactive } from "petite-vue"
import 'lite-youtube-embed'
import { poll, urlify, tagify, intersectionObserver, formatDate, toolbarOptions } from './utils.js'
import Quill from 'quill'

const parser = document.createElement('a')
parser.href = window.location
const tag = parser.hash
// const paths = pathname.split('/').filter(p => p)


const app = reactive({
    posts: [],
    hasNewPosts: false,
    interval: 30000,
    postBody: 'type something...',
    loginData: '',
    isLoggedIn: false,
    showLogin: false,
    initLoadAmount: 20,
    offset: 0,
    endOfList: false,
    loading: true,
    newPost: null,
    newPosts: [],
    quill: null,
    emptyState: null,
    async fetchPosts(loadAmount = 0) {
        if (this.endOfList) return

        this.offset += loadAmount
        const res = await fetch(`/api/posts/?by=created_at&order=desc&limit=${this.initLoadAmount}&offset=${this.offset}`)
        const data = await res.json()

        if (data.error) {
            this.endOfList = true
            this.loading = false
            return
        }

        if (data.length) {

            let posts = data.map(p => ({ ...p, post: urlify(p.post) }))
            posts = posts.map(p => ({ ...p, post: tagify(p.post) }))

            const allPosts = [...this.posts, ...posts]
            this.posts = allPosts

            if (!!tag) {
                this.filterPostsByTag()
            }

            const observer = intersectionObserver(() => this.fetchPosts(20))
            observer.observe(document.querySelector('.load-next'))
        }
        this.loading = false
        setTimeout(() => this.checkForNewPostUpdates(), 10000)
    },

    filterPostsByTag() {
        this.posts = this.posts.filter(p => p.post.includes(tag))
    },

    async fetchPostById(postId) {
        const res = await fetch(`/api/posts/${postId}`)
        const post = await res.json()
        console.log(post)

        if (post.error) {
            this.endOfList = true
            this.loading = false

            this.emptyState = {
                message: `
            <h2>404</h2>
            <p>That post does not exist. <a href="/">Back to home</a></p>
          `
            }
            return
        }

        if (post.id) {
            let posts = [post]
            posts = posts.map(p => ({ ...p, post: urlify(p.post) }))
            posts = posts.map(p => ({ ...p, post: tagify(p.post) }))

            const allPosts = [...this.posts, ...posts]
            this.posts = allPosts
        }
        this.endOfList = true
        this.loading = false
    },

    async createPost(e) {
        e.preventDefault()
        if (!this.isLoggedIn) return

        const html = document.querySelector('.ql-editor').innerHTML
        const tempTextarea = document.createElement("textarea")
        tempTextarea.innerHTML = html

        const isEmpty = tempTextarea.value === '<p><br></p>'
        if (isEmpty) return

        const post = {
            post: tempTextarea.value,
            author: 'alex',
        }

        const res = await fetch('/api/posts/', {
            method: 'POST',
            body: JSON.stringify(post),
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
        })

        const data = await res.json()

        if (data.success) {
            this.quill.setText('\n')

            let postText = urlify(post.post)
            postText = tagify(postText)
            const currentId = this.posts[0].id

            this.newPost = { ...post, post: postText, created_at: 'Just now', id: currentId + 1 }
            this.newPosts = [this.newPost, ...this.newPosts]

            this.quill.focus()
        }
    },

    checkForNewPostUpdates() {
        poll(() => new Promise(async () => {
            let firstPostId = this.posts[0]?.id
            if (!firstPostId) return

            const res = await fetch(`/api/posts/?by=created_at&order=desc&limit=${this.initLoadAmount}&offset=${this.offset}`)
            const posts = await res.json()

            if (posts.length) {
              const postIds = posts.map(p => p.id)
              const firstPostIndex = postIds.indexOf(firstPostId)
              this.newPosts = posts.slice(0, firstPostIndex)
                .map(p => ({...p, post: urlify(p.post)}))
                .map(p => ({...p, post: tagify(p.post)}))
            }
        }), this.interval)
    },

    async deletePost(id) {
        const res = await fetch(`/api/posts/${id}`, {
            method: 'DELETE',
            headers: {
                'Content-Type': 'application/json'
                // 'Content-Type': 'application/x-www-form-urlencoded',
            },
        })
        const updatedPosts = this.posts.filter(p => p.id !== id)
        this.newPosts = this.newPosts.filter(p => p.id !== id)
        this.posts = updatedPosts
        return await res.json()
    },

    formatDate,



    async fetchLogin() {
        const res = await fetch('/login', {
            method: 'GET',
            headers: {
                'Content-Type': 'text/html'
            }
        })

        const data = await res.text()
        this.loginData = data
    },

    async handleSubmitLogin(e) {
        e.preventDefault()
        const formData = new FormData(e.srcElement)
        this.loginData = ''

        const res = await fetch('/login/', {
            method: 'post',
            body: formData,
        })
        const data = await res.json()

        this.loginData = data.data
        this.isLoggedIn = data.loggedIn

        this.showLogin = false
    },

    async handleSubmitLogout(e) {
        e.preventDefault()
        const res = await fetch('/login?action=logout')
        const data = await res.json()

        this.loginData = data.data
        this.isLoggedIn = data.loggedIn

    },

    checkIfLoggedIn(loggedin) {
        this.isLoggedIn = !!loggedin
    },

    loadEditor() {
        this.quill = new Quill('.editor', {
            theme: 'snow',
            modules: {
                toolbar: toolbarOptions
            }
        })

        this.quill.on('text-change', (delta, _old, _source) => {
            if (this.quill.getLength() <= 500) {
                return
            }
            const { ops } = delta
            let updatedOps
            if (ops.length === 1) {
                // text is inserted at the beginning
                updatedOps = [{ delete: ops[0].insert.length }]
            } else {
                // ops[0] == {retain: numberOfCharsBeforeInsertedText}
                // ops[1] == {insert: "example"}
                updatedOps = [ops[0], { delete: ops[1].insert.length }]
            }
            this.quill.updateContents({ ops: updatedOps })
        })
    },

})


createApp({ app }).mount("#app")


